export const REGISTER_FETCH_ENTITY = 'REGISTER_FETCH_ENTITY';
export const FETCH = 'FETCH';
export const SET_FETCH_ENTITY_RESPONSE = 'SET_FETCH_ENTITY_RESPONSE';
export const SET_FETCH_ENTITY_LOADING = 'SET_FETCH_ENTITY_LOADING';
export const SET_FETCH_ENTITY_ERROR = 'SET_FETCH_ENTITY_ERROR';
export const LOGIN = 'LOGIN';
